'use client';

import { FC, useEffect, useRef } from 'react';
import { CategorySeoFriendlyProps } from '@/containers/CategoryPage/CategorySeoFriendly/types';

const CategorySeoFriendly: FC<CategorySeoFriendlyProps> = ({ className, seoFriendlyText, isSellerPage }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isSellerPage) return;
    const container = containerRef.current;
    if (!container) return;

    const handleInput = (e: any) => {
      let x = e.target.value.replace(/\D/g, '').slice(0, 10); // digits only, max 10
      let formatted = x;

      if (x.length > 6) {
        formatted = `(${x.slice(0, 3)}) ${x.slice(3, 6)}-${x.slice(6)}`;
      } else if (x.length > 3) {
        formatted = `(${x.slice(0, 3)}) ${x.slice(3)}`;
      }

      e.target.value = formatted;
    };

    const handleBlur = (e: any) => {
      const input = e.target as HTMLInputElement;
      input.value = input.value.trim();
      if (input.value === '') {
        input.value = '';
      }
    };

    const form = container.querySelector('#becomeseller');
    const phoneInput = container.querySelector('#phoneId');
    const emailInput = container.querySelector('#emailId');

    if (form) {
      form.addEventListener('submit', (e) => {
        if (form.classList.contains('is-submitting')) {
          e.preventDefault();
        }
        form.classList.add('is-submitting');
      });
    }
    if (phoneInput) {
      phoneInput.addEventListener('input', handleInput);
    }

    if (emailInput) {
      emailInput.removeAttribute('onblur');
      emailInput.addEventListener('blur', handleBlur);
    }

    return () => {
      if (phoneInput) {
        phoneInput.removeEventListener('input', handleInput);
      }
      if (emailInput) {
        emailInput.removeEventListener('blur', handleBlur);
      }
    };
  }, [seoFriendlyText]);

  return <div ref={containerRef} className={className} dangerouslySetInnerHTML={{ __html: seoFriendlyText }} />;
};

export default CategorySeoFriendly;
